export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6935.31b0558a.jpg";